import addNewProgram from '../../assets/navbar/addition.png';
import allMyPrograms from '../../assets/navbar/programs.png';
import resources from '../../assets/navbar/resources.png';
import transactions from '../../assets/navbar/transactions.png';
import settings from '../../assets/navbar/settings.png';
import signout from '../../assets/navbar/signout.png';
import userProfile from '../../assets/navbar/userProfile.png';

export const dropdownArray = [
  {
    id: 'Add new program',
    title: 'Add new program',
    path: '/design/add/new',
    cName: 'dropdn-link-prsogram',
    src: addNewProgram,
  },
  {
    id: 'All my programs',
    title: 'All my programs',
    path: '/my-programs',
    cName: 'dropdn-link-program',
    src: allMyPrograms,
  },
];

export const userDropdownArray = [
  {
    id: 'My Profile',
    title: 'My Profile',
    path: '/profile',
    cName: 'dropdn-link',
    src: userProfile,
  },
  {
    id: 'Resources',
    title: 'Resources',
    path: '/resources',
    cName: 'dropdn-link',
    src: resources,
  },
  {
    id: 'Transactions',
    title: 'Transactions',
    path: '/transactions',
    cName: 'dropdn-link',
    src: transactions,
  },
  { id: 'Settings', title: 'Settings', path: '/settings', cName: 'dropdn-link', src: settings },
  { id: 'Sign Out', title: 'Sign Out', path: '/signout', cName: 'dropdn-link', src: signout },
];

export const navLinksArray = ['Who We Are', 'What We Do', 'Blog'];

export const navbarData = [
  {
    id: 'My Program',
    heading: 'My Program',
    content: dropdownArray,
  },
  {
    id: 'user',
    img: userProfile,
    heading: '',
    content: userDropdownArray,
  },
];
